import { useQuery } from 'react-query';
import RentForecastService from '../../services/rentForecastService';
import type { RentForecastResponse } from './types';

const useRentForecastQuery = (
  organizationId,
  propertyId,
  callback,
): { data: ?RentForecastResponse, ...Object } => {
  const queryKey = ['useRentForecastQuery', organizationId, propertyId];
  return useQuery(
    queryKey,
    async () => {
      return new RentForecastService().getAllRentForecast(
        organizationId,
        propertyId,
      );
    },
    {
      enabled: Boolean(propertyId && organizationId),
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        callback(data);
      },
    },
  );
};

export default useRentForecastQuery;
